<div class="flex-markers-container">
    @switch (targetedFieldValues) {
      @case (chartMarkers.NONE) {
        <span class="no-marker"></span>
      }
      @case (chartMarkers.COLOR) {
        <img src="assets/images/markers/color_option.svg" alt="color" />
      }
      @case (chartMarkers.SHAPE) {
        <img src="assets/images/markers/shape_option.svg" alt="shape" />
      }
    }

  @if (advancedMode()) {
  <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    @for (option of options; track option.chartMarker) {
      @if(!selectedChartMarkers().includes(option.chartMarker) && option.chartMarker !== targetedFieldValues) {
        <button mat-menu-item (click)="saveChartMarker(option.chartMarker)">
          <div class="flex-row">
            @if (option.path && option.chartMarker !== ChartMarkers.NONE) {
              <img [src]=option.path [alt]=option.chartMarker />
            }
            <span class="text-center">{{ capitalize(option.chartMarker) }}</span>
          </div>
        </button>
      }
    }
  </mat-menu>
  }

</div>
